// extracted by mini-css-extract-plugin
export var currentStep = "_hg-2";
export var nodeCard = "_hg-0";
export var pathHighlighted = "_hg-1";